import React from 'react';
import type { CSS } from '@components-shared/src/stitches';
import { ErrorMessage } from '../alerts';
import { TextAreaContainer } from '../inputStyles';
import { InputArea } from './shared';

type TextAreaProps = {
  hasError?: boolean;
  errorMsg?: string;
  css?: CSS;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ hasError, errorMsg, css, ...props }, forwardedRef) => {
    return (
      <TextAreaContainer css={css}>
        <InputArea hasError={hasError} ref={forwardedRef} {...props} css={css} />
        {hasError && <ErrorMessage>{errorMsg}</ErrorMessage>}
      </TextAreaContainer>
    );
  },
);

TextArea.displayName = 'TextArea';
